<script setup lang="ts">
import { isVNode } from 'vue'
import { useToast } from './use-toast'

const { toast, toasts } = useToast()

const flashedToasts = useProperty<App.Data.ToastData[]>('toasts')
watch(flashedToasts, (flashedToasts) => {
	flashedToasts.forEach((flashedToast) => {
		toast({
			title: flashedToast.title,
			description: flashedToast.description ?? '',
			variant: flashedToast.variant,
		})
	})
})
</script>

<template>
	<ui-toast-provider>
		<ui-toast v-for="toastItem in toasts" :key="toastItem.id" v-bind="toastItem">
			<div class="grid gap-1">
				<ui-toast-title v-if="toastItem.title" class="flex items-center gap-2">
					<i-ph-check-circle-bold v-if="toastItem.variant === 'successful'" class="size-5 shrink-0" />
					<i-ph-info-bold v-if="toastItem.variant === 'informative'" class="size-5 shrink-0" />
					<i-ph-warning-bold v-if="toastItem.variant === 'destructive'" class="size-5 shrink-0" />
					{{ toastItem.title }}
				</ui-toast-title>
				<template v-if="toastItem.description">
					<ui-toast-description v-if="isVNode(toastItem.description)">
						<component :is="toastItem.description" />
					</ui-toast-description>
					<ui-toast-description v-else>
						{{ toastItem.description }}
					</ui-toast-description>
				</template>
				<ui-toast-close />
			</div>
			<component :is="toastItem.action" />
		</ui-toast>
		<ui-toast-viewport />
	</ui-toast-provider>
</template>
